// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

.jp-ThemedContainer {
  /* Decrease default density for Jupyter toolkit components */
  --density: -4;
}

/* Styles for tree view */
.jp-TreeView {
  min-width: auto;
}

.jp-TreeView.jp-mod-flat > .jp-TreeItem::part(content-region) {
  margin-inline-start: calc(var(--design-unit) * 2px);
}

/* Styles for tree item */
.jp-TreeItem::part(expand-collapse-button) {
  color: var(--jp-inverse-layout-color3);
}

/* Tune hover for stealth buttons otherwise they won't stand out */
.jp-TreeItem jp-button[appearance='stealth']:hover {
  background: var(--tree-item-expand-collapse-hover);
}

.jp-TreeItem[selected] jp-button[appearance='stealth']:hover {
  background: var(--tree-item-expand-collapse-selected-hover);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/ui-components/style/toolkit.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E;EACE,4DAA4D;EAC5D,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;AACxC;;AAEA,kEAAkE;AAClE;EACE,kDAAkD;AACpD;;AAEA;EACE,2DAA2D;AAC7D","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n.jp-ThemedContainer {\n  /* Decrease default density for Jupyter toolkit components */\n  --density: -4;\n}\n\n/* Styles for tree view */\n.jp-TreeView {\n  min-width: auto;\n}\n\n.jp-TreeView.jp-mod-flat > .jp-TreeItem::part(content-region) {\n  margin-inline-start: calc(var(--design-unit) * 2px);\n}\n\n/* Styles for tree item */\n.jp-TreeItem::part(expand-collapse-button) {\n  color: var(--jp-inverse-layout-color3);\n}\n\n/* Tune hover for stealth buttons otherwise they won't stand out */\n.jp-TreeItem jp-button[appearance='stealth']:hover {\n  background: var(--tree-item-expand-collapse-hover);\n}\n\n.jp-TreeItem[selected] jp-button[appearance='stealth']:hover {\n  background: var(--tree-item-expand-collapse-selected-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
